import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import sureSpaceLogo from '../../assets/logo.png';
import { getAuthPageCardSx, getAuthPageShellSx } from '../../styles/portalSurfaces';

const AuthPageShell = ({ title, subtitle, children, footer }) => {
  const theme = useTheme();

  return (
    <Box sx={getAuthPageShellSx()}>
      <Box sx={getAuthPageCardSx(theme)}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <Box
            component="img"
            src={sureSpaceLogo}
            alt=""
            sx={{ width: 40, height: 40, objectFit: 'contain', mb: 1.5 }}
          />
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 800,
              letterSpacing: '0.3px',
              color: 'text.primary',
              lineHeight: 1,
            }}
          >
            SURE
            <Box component="span" sx={{ color: 'primary.main' }}>
              SPACE
            </Box>
          </Typography>
        </Box>
        <Typography color="primary.main" fontWeight={600} variant="h5" align="center" gutterBottom>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 2 }}>
            {subtitle}
          </Typography>
        ) : null}
        {children}
        {footer ? <Box sx={{ mt: 2 }}>{footer}</Box> : null}
      </Box>
    </Box>
  );
};

export default AuthPageShell;
